// extracted by mini-css-extract-plugin
export default {"noBackground":"hea-z","qnaContainer":"iea-z","qna":"jea-z","question":"kea-z","modal":"lea-z"};